'use client';

import { buildSortedFeatures } from '@/utils/features/build-features';
import clsx from 'clsx';

import { FeatureItem } from './feature-item';

export const FeaturesGroup: React.FC<{
  anchor?: 'left' | 'right';
  className?: string;
  features: ReturnType<typeof buildSortedFeatures>;
}> = ({ anchor, features, className }) => {
  return (
    <ul className={clsx('grid grid-cols-2 gap-4', className)}>
      {features.map((feature, index) => {
        return (
          <FeatureItem
            key={`feature-${feature.name}-${index}`}
            feature={feature}
            anchor={anchor || ((index + 1) % 2 ? 'left' : 'right')}
          />
        );
      })}
    </ul>
  );
};
